jQuery(document).ready(function($) {
    // Modify "Support" submenu item
    var supportSubMenu = $('#toplevel_page_thha-addons-manager a[href$="tab=support"]');
    if (supportSubMenu.length) {
        supportSubMenu.attr('href', thhaAdminData.support_url);
        supportSubMenu.attr('target', '_blank');
        supportSubMenu.attr('rel', 'noopener noreferrer');
    }

    // Modify "Unlock Pro Features" submenu item (if it exists)
    var unlockProSubMenu = $('#toplevel_page_thha-addons-manager a[href$="tab=unlock-pro"]');
    if (unlockProSubMenu.length) {
        unlockProSubMenu.attr('href', thhaAdminData.pricing_url);
        unlockProSubMenu.attr('target', '_blank');
        unlockProSubMenu.attr('rel', 'noopener noreferrer');
    }
});
